export default {
  state: () => ({
    carouselImages: [
      {
        src: "/BannerIncocegla.png",
        title: "Lorem ipsum dolor sit amet",
        description: "Lorem ipsum dolor sit amet",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        title: "Lorem ipsum dolor sit amet",
        description: "Lorem ipsum dolor sit amet",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        title: "Lorem ipsum dolor sit amet",
        description: "Lorem ipsum dolor sit amet",
      },
      {
        src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        title: "Lorem ipsum dolor sit amet",
        description: "Lorem ipsum dolor sit amet",
      },
    ],
  }),
  getters: {
    getCarouselImages: (state) => state.carouselImages,
  },
  mutations: {},
  actions: {},
  namespaced: true,
};
